<div class="p-grid" style="margin: 15px;">
  <p-panel header="Liste des profils à modérer de type retour" class="p-col-12" styleClass="panel-head" [style]="panelStyle()">
    <p-table [value]="moderations" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="header">
        <tr>
          <th>Client</th>
          <th>Etat</th>
       <!--   <th>Retour</th>-->
          <th>Complexite</th>
          <th>Responsable</th>
          <th style="width: 125px; ">Modérer</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-moderation>
        <tr>
          <td> {{moderation.client}} </td>
          <td> {{moderation.etat}} </td>
  <!--        <td> {{moderation.retour}} </td>-->
          <td> {{moderation.complexite}} </td>
          <td> {{moderation.responsable}} </td>
          <td align="center"> <button pButton type="button"  icon="pi pi-id-card" class="ui-button-warning" style="width: 55px;"></button> </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>

</div>
